var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_626_732",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_626_732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.53341 23.2667C8.84453 22.3851 10.189 21.7092 11.5667 21.239C12.9445 20.7685 14.4223 20.5333 16.0001 20.5333C17.5779 20.5333 19.0593 20.7685 20.4444 21.239C21.8298 21.7092 23.178 22.3851 24.4891 23.2667C25.4002 22.1629 26.065 21.011 26.4834 19.811C26.9019 18.611 27.1111 17.3407 27.1111 16C27.1111 12.8667 26.0426 10.2314 23.9057 8.09432C21.7686 5.95744 19.1334 4.88899 16.0001 4.88899C12.8667 4.88899 10.2315 5.95744 8.09442 8.09432C5.95753 10.2314 4.88908 12.8667 4.88908 16C4.88908 17.3407 5.10197 18.611 5.52775 19.811C5.95375 21.011 6.6223 22.1629 7.53341 23.2667ZM15.9961 17.111C14.7025 17.111 13.6131 16.6671 12.7277 15.7793C11.8426 14.8913 11.4001 13.8005 11.4001 12.507C11.4001 11.2134 11.8441 10.1241 12.7321 9.23899C13.6199 8.35366 14.7105 7.91099 16.0041 7.91099C17.2976 7.91099 18.3871 8.35499 19.2724 9.24299C20.1575 10.131 20.6001 11.2218 20.6001 12.5153C20.6001 13.8089 20.1561 14.8982 19.2681 15.7833C18.3803 16.6684 17.2896 17.111 15.9961 17.111ZM15.9911 29.3333C14.1444 29.3333 12.4091 28.9833 10.7851 28.2833C9.16086 27.5833 7.74808 26.6297 6.54675 25.4223C5.34519 24.2148 4.39819 22.8011 3.70575 21.1813C3.01308 19.5615 2.66675 17.8308 2.66675 15.989C2.66675 14.1472 3.01675 12.4163 3.71675 10.7963C4.41675 9.17655 5.37041 7.76666 6.57775 6.56666C7.7853 5.36666 9.19897 4.41666 10.8187 3.71666C12.4385 3.01666 14.1693 2.66666 16.0111 2.66666C17.8529 2.66666 19.5837 3.01666 21.2037 3.71666C22.8235 4.41666 24.2334 5.36666 25.4334 6.56666C26.6334 7.76666 27.5834 9.17777 28.2834 10.8C28.9834 12.4222 29.3334 14.1535 29.3334 15.994C29.3334 17.8347 28.9834 19.5643 28.2834 21.183C27.5834 22.8017 26.6334 24.2148 25.4334 25.4223C24.2334 26.6297 22.8213 27.5833 21.1971 28.2833C19.5731 28.9833 17.8377 29.3333 15.9911 29.3333Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUser);
export default __webpack_public_path__ + "static/media/contactUser.5ec9936e7c4a76c10ec94b30bc86f8b4.svg";
export { ForwardRef as ReactComponent };